import {
  FaUserCircle,
  FaCalendarAlt,
  FaPaperclip,
  FaReply,
  FaTimes,
} from "react-icons/fa";
import { BsCheckCircle } from "react-icons/bs";
import { useContext, useState, useEffect } from "react";
import { AppContext, mainAPikey } from "../../../ContextApi";
import { NotokenFound } from "../../../Utils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { noChatHistory } from "../../../Assets";

const TicketDetails = ({
  setShowTicketPoup,
  setViewType,
  selectedQueryId,
  ticketDetailsData,
  repliesData,
  isActiveFooter,
}) => {
  const handleReply = () => {
    setViewType(2);
    setShowTicketPoup(false);
  };

  const { requestOptions, setCallQueryListApi } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(false);

  const handleMarkResolved = () => {
    setIsLoading(true);

    const data = {
      query_id: selectedQueryId,
    };

    const requestOptionsCopy = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...requestOptions.headers,
      },
      body: JSON.stringify(data),
    };

    fetch(
      `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/mark-ticket-resolved`,
      requestOptionsCopy
    )
      .then((response) => response.json())
      .then((res) => {
        setIsLoading(false);
        if (res.success) {
          toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          setShowTicketPoup(false);
          setCallQueryListApi(true);
        } else {
          toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error submitting form:", error);
        toast.error("Something went wrong!");
      });
  };

  return (
    <div className="ticket-container">
      {repliesData?.length > 0 ? (
        <>
          <div className="ticket-messages">
            {repliesData?.map((msg) => (
              <div className="ticket-message" key={msg.id}>
                <div className="ticket-message-header">
                  <FaUserCircle className="ticket-avatar" />
                  <strong className="ticket-username">{msg.name}</strong>
                  <div className="ticket-date">
                    <FaCalendarAlt /> <span>Posted On: {msg.created_at}</span>
                  </div>
                </div>
                <div className="ticket-message-body">{msg.message}</div>

                {msg.documents?.length > 0 && (
                  <div className="ticket-attachment">
                    <FaPaperclip /> <span>Attachments:</span>
                    {msg.documents.map((doc, index) => (
                      <div key={index} className="ticket-attachment-file">
                        <a href={doc?.file_url} target="_blank">
                          {doc?.original_file_name}
                        </a>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="no-chat-history-main-cover-wrapper">
          <img src={noChatHistory} alt="No Chat History"></img>
          <h6 className="text-center">No Chat history</h6>
        </div>
      )}
      {isActiveFooter && (
        <div className="ticket-actions">
          {ticketDetailsData?.status !== "Open" ? (
            <button className="ticket-btn status">
              {ticketDetailsData?.status}
            </button>
          ) : (
            <>
              <button
                className="ticket-btn reply"
                onClick={() => handleReply()}
              >
                <FaReply /> Reply
              </button>
              {repliesData?.length > 0 && (
                <button
                  className="ticket-btn end"
                  disabled={isLoading}
                  onClick={() => handleMarkResolved()}
                >
                  <BsCheckCircle /> {isLoading ? "Loading..." : "Mark Resolved"}
                </button>
              )}
            </>
          )}
        </div>
      )}

      {/* <div className="ticket-footer">
        <button className="ticket-btn close">
          <FaTimes /> Close
        </button>
      </div> */}
    </div>
  );
};

export default TicketDetails;
